import { useEffect, useState } from 'react';
import { getAccessToken } from './tokenUtils';

export const useAuthenticatedObjectUrl = (url: string): string => {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    if (!url) {
      setObjectUrl('');
      return undefined;
    }

    const controller = new AbortController();
    let createdUrl = '';

    const load = async () => {
      try {
        const token = getAccessToken();
        const response = await fetch(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          signal: controller.signal,
          cache: 'no-store',
        });
        if (!response.ok) throw new Error(`Media request failed: ${response.status}`);
        const blob = await response.blob();
        createdUrl = URL.createObjectURL(blob);
        setObjectUrl(createdUrl);
      } catch {
        if (!controller.signal.aborted) setObjectUrl('');
      }
    };

    void load();

    return () => {
      controller.abort();
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url]);

  return objectUrl;
};
